function normalizeTimezone(timezone) {
  return timezone || "UTC";
}

export function getPlanningDateString(timezone = "UTC", date = new Date()) {
  const safeTimezone = normalizeTimezone(timezone);

  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: safeTimezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  } catch (_error) {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  }
}

export function addDaysToPlanningDateString(dateString, days) {
  const [year, month, day] = String(dateString || "").split("-").map(Number);
  if (!year || !month || !day) return "";

  const next = new Date(Date.UTC(year, month - 1, day));
  next.setUTCDate(next.getUTCDate() + days);

  return [
    next.getUTCFullYear(),
    String(next.getUTCMonth() + 1).padStart(2, "0"),
    String(next.getUTCDate()).padStart(2, "0"),
  ].join("-");
}

function parsePlanningDate(dateString) {
  const [year, month, day] = String(dateString || "").split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(Date.UTC(year, month - 1, day));
}

export function formatPlanningDate(dateString, options, locale) {
  const parsed = parsePlanningDate(dateString);
  if (!parsed) return "";

  return parsed.toLocaleDateString(locale, {
    timeZone: "UTC",
    ...options,
  });
}

export function getPlanningRelativeDateLabel(
  dateString,
  timezone = "UTC",
  date = new Date(),
) {
  const today = getPlanningDateString(timezone, date);

  if (dateString === today) return "Today";
  if (dateString === addDaysToPlanningDateString(today, 1)) return "Tomorrow";
  if (dateString === addDaysToPlanningDateString(today, -1)) return "Yesterday";

  return formatPlanningDate(
    dateString,
    { weekday: "long", month: "short", day: "numeric" },
  );
}
